//import { Hub } from "aws-amplify";
import { getCurrentUser as amplifyGetCurrentUser } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import store from "../appStore";

const getCurrentUser = async () => {
  try {
    return await amplifyGetCurrentUser();
  } catch {
    return null;
  }
};

const useAuth = () => {
  // const [currentUser, setCurrentUser] = useState(null);

  const { currentUser } = useSnapshot(store);

  // useEffect(() => {
  //   const updateUser = async () => {
  //     setCurrentUser(await getCurrentUser());
  //   };
  //   Hub.listen("auth", updateUser);
  //   updateUser();
  //   return () => Hub.remove("auth", updateUser);
  // }, []);

  return { currentUser };
};

export default useAuth;
